import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function HamburgerMenu() {
	const location = useLocation();

	return (
		<div className='dropdown-end dropdown'>
			<label tabIndex={0} className='btn btn-ghost'>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					fill='none'
					viewBox='0 0 24 24'
					strokeWidth={2}
					stroke='currentColor'
					className='h-9 w-9 text-accent'
				>
					<path
						strokeLinecap='round'
						strokeLinejoin='round'
						d='M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5'
					/>
				</svg>
			</label>
			<ul
				tabIndex={0}
				className='dropdown-content menu w-64 bg-success p-2 text-neutral shadow-lg '
			>
				<li>
					<Link to='/' className={location.pathname === '/' ? 'bg-accent' : ''}>
						Home
					</Link>
				</li>
				<li>
					<Link
						to='/about'
						className={location.pathname === '/about' ? 'bg-accent' : ''}
					>
						About
					</Link>
				</li>
				<li>
					<Link
						to='/calendar'
						className={location.pathname === '/calendar' ? 'bg-accent' : ''}
					>
						Calendar
					</Link>
				</li>
				<li>
					<Link
						to='/families'
						className={location.pathname === '/families' ? 'bg-accent' : ''}
					>
						Families
					</Link>
				</li>
				<li>
					<Link
						to='/gallery'
						className={location.pathname === '/gallery' ? 'bg-accent' : ''}
					>
						Gallery
					</Link>
				</li>
			</ul>
		</div>
	);
}

export default HamburgerMenu;
